export default __webpack_public_path__ + "static/0184-1391a5374c57d868eddec90c43304518.png";